__webpack_require__.p = "/Coin-Toss-Game-React/";